document.addEventListener("DOMContentLoaded", () => {
  const root     = document.getElementById("madBalanceQuiz");
  if (!root) return;

  const stage    = root.querySelector(".mbq__stage");
  const allSteps = Array.from(root.querySelectorAll(".mbq__step"));
  const bar      = root.querySelector(".mbq__progress-bar");
  const counter  = root.querySelector(".mbq__counter");
  const btnBack  = root.querySelector(".mbq__back");
  const btnNext  = root.querySelector(".mbq__cta");
  const actions  = root.querySelector(".mbq__actions");
  const banner   = root.querySelector(".mbq__banner"); // << banner element

  let idx = 0;
  let showFollowupYes = false;
  const DURATION = 400; // ms

  // Which steps are currently part of the flow (handles conditional ones)
  const visibleSteps = () =>
    allSteps.filter(s => {
      const cond = s.getAttribute("data-conditional");
      if (!cond) return true;
      if (cond === "followup_yes") return showFollowupYes;
      return false;
    });

  // Init visibility
  allSteps.forEach((s, i) => {
    if (i === 0) {
      s.classList.add("active");
      s.classList.remove("is-hidden", "leaving");
    } else {
      s.classList.add("is-hidden");
      s.classList.remove("active", "leaving");
    }
  });

  // Lock stage height to current step (for smooth transitions)
  function setStageHeight(forStep) {
    if (!stage || !forStep) return;
    const wasHidden = forStep.classList.contains("is-hidden");
    if (wasHidden) {
      forStep.style.visibility = "hidden";
      forStep.style.display = "block";
    }
    const h = forStep.offsetHeight;
    stage.style.height = h + "px";
    if (wasHidden) {
      forStep.style.visibility = "";
      forStep.style.display = "";
    }
  }

  // Subtle scroll-to-top of quiz on slide change
  function scrollQuizToTop() {
    if (!root) return;
    const rect = root.getBoundingClientRect();
    const targetTop = rect.top + window.pageYOffset - 20;
    if (window.pageYOffset > targetTop + 5) {
      window.scrollTo({ top: targetTop, behavior: "auto" });
    }
  }

  // Progress bar + counter
  function updateMeta(vis) {
    const total = vis.length || 1;
    const current = idx + 1;
    const pct = (current / total) * 100;

    if (bar) {
      bar.style.setProperty("width", pct + "%", "important");
      bar.style.setProperty("opacity", "1", "important");
    }
    if (counter) {
      counter.textContent = current + " / " + total;
    }
  }

  // Continue button state
  function updateCtaState(step) {
    if (!btnNext || !step) return;
    const type = step.dataset.type;
    let enableNext = false;

    if (type === "single") {
      enableNext = false; // single auto-advances
    } else if (type === "multi") {
      enableNext = step.querySelectorAll(".mbq__pill.selected").length > 0;
    } else if (type === "info" || type === "final") {
      enableNext = true;
    }

    btnNext.toggleAttribute("disabled", !enableNext);
    btnNext.textContent = type === "final" ? "Start Now →" : "Continue";
  }

  // Show/hide bottom actions (Back/Continue)
  function updateActions() {
    if (!actions) return;
    actions.style.display = (idx === 0) ? "none" : "flex";
  }

  // Show banner only on first slide
  function updateBanner() {
    if (!banner) return;
    banner.style.display = (idx === 0) ? "block" : "none";
  }

  // Core transition
  function goTo(newIdx) {
    const vis = visibleSteps();
    const from = vis[idx];
    idx = Math.max(0, Math.min(newIdx, vis.length - 1));
    const to = vis[idx];

    if (!to) return;

    if (from === to) {
      setStageHeight(to);
      scrollQuizToTop();
      updateMeta(vis);
      updateCtaState(to);
      updateActions();
      updateBanner();
      return;
    }

    // Prepare incoming
    to.classList.remove("is-hidden", "leaving");
    void to.offsetWidth; // force reflow
    setStageHeight(to);
    to.classList.add("active");

    // Animate outgoing
    if (from) {
      from.classList.add("leaving");
      from.classList.remove("active");
      const clean = el => {
        el.classList.add("is-hidden");
        el.classList.remove("leaving");
      };
      const onEnd = () => {
        from.removeEventListener("transitionend", onEnd);
        clean(from);
      };
      from.addEventListener("transitionend", onEnd);
      setTimeout(() => {
        if (from.isConnected) clean(from);
      }, DURATION + 50);
    }

    scrollQuizToTop();
    updateMeta(vis);
    updateCtaState(to);
    updateActions();
    updateBanner();
  }

  const next = () => goTo(idx + 1);
  const prev = () => goTo(idx - 1);

  // Nav buttons
  btnBack?.addEventListener("click", prev);

  btnNext?.addEventListener("click", () => {
    const vis = visibleSteps();
    const step = vis[idx];
    if (!step) return;

    const type = step.dataset.type;
    if (type === "final") {
      window.location.href = root.dataset.redirect || "/";
      return;
    }
    next();
  });

  // Wire answers
  allSteps.forEach(step => {
    const type  = step.dataset.type;
    const key   = step.dataset.key;
    const pills = step.querySelectorAll(".mbq__pill");

    // Single choice: auto-advance
    if (type === "single") {
      pills.forEach(p => {
        p.addEventListener("click", () => {
          pills.forEach(x => x.classList.remove("selected"));
          p.classList.add("selected");

          if (key === "takes_supplement") {
            showFollowupYes = p.dataset.branch === "followup_yes";
          }

          setTimeout(next, 200);
        });
      });
    }

    // Multi choice: require at least one to enable Continue
    if (type === "multi") {
      pills.forEach(p => {
        p.addEventListener("click", () => {
          p.classList.toggle("selected");
          const vis = visibleSteps();
          const current = vis[idx];
          if (current === step && btnNext) {
            const any = step.querySelectorAll(".mbq__pill.selected").length > 0;
            btnNext.toggleAttribute("disabled", !any);
          }
        });
      });
    }
  });

  // Expand / collapse cards (perimenopause support slide)
  const expandItems = root.querySelectorAll(".mbq__expand-item");
  expandItems.forEach(item => {
    const btn = item.querySelector(".expand-toggle");
    if (!btn) return;

    item.addEventListener("click", () => {
      const isActive = item.classList.toggle("active");
      btn.textContent = isActive ? "−" : "+";

      const vis = visibleSteps();
      const current = vis[idx];
      if (current && current.contains(item)) {
        setStageHeight(current);
      }
    });
  });

  // Initial state
  setStageHeight(allSteps[0]);
  updateMeta(visibleSteps());
  updateCtaState(allSteps[0]);
  updateActions(); // hide actions on first slide
  updateBanner();  // show banner only on first slide

  // Keep height in sync on resize
  window.addEventListener("resize", () => {
    const vis = visibleSteps();
    const current = vis[idx];
    if (current) setStageHeight(current);
  });
});


// === Mad Glow | UTM forwarder to *.madglow.com ===
(function () {
  var KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid"];

  function getLandingParams() {
    var src = new URLSearchParams(window.location.search);
    var keep = new URLSearchParams();
    KEYS.forEach(function (k) { if (src.has(k)) keep.set(k, src.get(k)); });
    return keep;
  }

  function paramsToObject(sp) {
    var o = {}; sp.forEach(function (v, k) { o[k] = v }); return o;
  }

  // Persist within the session (in case user clicks after nav within site)
  var landing = getLandingParams();
  if ([].concat(KEYS).some(function (k) { return landing.has(k); })) {
    sessionStorage.setItem("mg_utms", landing.toString());
  } else if (sessionStorage.getItem("mg_utms")) {
    landing = new URLSearchParams(sessionStorage.getItem("mg_utms"));
  }

  function hasAnyKey(sp) {
    var found = false;
    KEYS.forEach(function (k) { if (sp.has(k)) found = true; });
    return found;
  }

  function decorateUrl(urlStr) {
    if (!urlStr) return urlStr;
    var url;
    try { url = new URL(urlStr, window.location.origin); }
    catch (e) { return urlStr; }

    // Decorate any host under madglow.com
    if (!/(\.|^)madglow\.com$/i.test(url.hostname)) return urlStr;

    // Merge without overwriting existing params
    landing.forEach(function (v, k) {
      if (!url.searchParams.has(k)) url.searchParams.set(k, v);
    });

    return url.toString();
  }

  // If we have stored UTMs and current page is madglow.com but missing them, add them (no reload)
  (function decorateCurrentLocationIfNeeded() {
    try {
      if (!hasAnyKey(landing)) return;
      if (!/(\.|^)madglow\.com$/i.test(location.hostname)) return;

      var current = new URL(window.location.href);
      var before = current.search;

      KEYS.forEach(function (k) {
        if (!current.searchParams.has(k) && landing.has(k)) {
          current.searchParams.set(k, landing.get(k));
        }
      });

      if (current.search !== before) {
        history.replaceState(null, "", current.toString());
      }
    } catch (e) { /* noop */ }
  })();

  function decorateAnchor(a) {
    if (!a || !a.getAttribute) return;
    var href = a.getAttribute("href");
    if (!href) return;
    var newHref = decorateUrl(href);
    if (newHref && newHref !== href) a.setAttribute("href", newHref);
  }

  function scanAnchors(root) {
    (root || document).querySelectorAll("a[href]").forEach(decorateAnchor);
  }

  function handleDataHref(el) {
    var href = el.getAttribute("data-href");
    if (!href) return;
    var decorated = decorateUrl(href);
    if (decorated && decorated !== href) el.setAttribute("data-href", decorated);
  }

  // Initial pass
  scanAnchors(document);
  document.querySelectorAll("[data-href]").forEach(handleDataHref);

  // MutationObserver for late-loaded content
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches("a[href]")) decorateAnchor(n);
        if (n.querySelectorAll) {
          scanAnchors(n);
          n.querySelectorAll("[data-href]").forEach(handleDataHref);
        }
      });
    });
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Click handler for data-href
  document.addEventListener("click", function (e) {
    var el = e.target.closest("a, [data-href]");
    if (!el) return;

    if (el.tagName === "A") return;

    var href = el.getAttribute("data-href");
    if (!href) return;

    var url;
    try { url = new URL(href, window.location.origin); }
    catch (err) { return; }

    if (/(\.|^)madglow\.com$/i.test(url.hostname)) {
      e.preventDefault();
      window.location.href = decorateUrl(href);
    }
  }, true);

  window.mgDecorateQuizUrl = function (u) { return decorateUrl(u); };
})();
